import { useEffect } from 'react';
// CommonJS module (shared with the Node prerender script); consume via require so
// webpack does not try to resolve named/default ESM exports off it.
const marketingSeo = require('./marketingSeo');

// Runtime JSON-LD + title for a marketing route. Injects the route's JSON-LD only
// if the statically prerendered HTML has not already placed it (id check), so:
//  - crawlers reading the static HTML see exactly one copy, and
//  - client-side SPA navigations still get the correct per-route schema.
// Source of truth is src/seo/marketingSeo.js, shared with the postbuild prerender
// script, so static and runtime never drift.
export default function useJsonLd(path) {
  useEffect(() => {
    const route = marketingSeo.getRoute(path);
    if (!route) return undefined;
    if (route.title) document.title = route.title;

    const id = `ld-${route.file}`;
    if (document.getElementById(id)) return undefined; // already in the static HTML

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = id;
    script.textContent = JSON.stringify(route.jsonLd);
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, [path]);
}
